document.addEventListener("DOMContentLoaded",function(){

// Blog foto links uitschakelen
document.querySelectorAll('.rte a, .rte--indented-images a').forEach(function(a){
  var href = a.getAttribute('href') || '';
  if(href.indexOf('cdn.shopify') !== -1 || href.match(/\.(jpg|jpeg|png|webp|gif)/i)){
    a.addEventListener('click', function(e){ e.preventDefault(); });
    a.style.cursor = 'default';
    a.style.pointerEvents = 'none';
  }
});

  // Create toast popup
  var d=document.createElement("div");
  d.id="wlToast";
  d.style.cssText="position:fixed;top:0;left:0;width:100%;background:#1a1a1a;color:#fff;padding:14px 20px;font-size:13px;letter-spacing:0.5px;text-align:center;z-index:99999;transform:translateY(-100%);transition:transform 0.4s ease;pointer-events:none;font-family:Inter,sans-serif;display:flex;justify-content:center;align-items:center;gap:20px;";
  d.innerHTML='<span id="wlToastText" style="color:#fff">Added to wishlist</span><a href="/pages/wishlist" id="wlToastLink" style="color:#fff;text-decoration:underline;text-underline-offset:3px;font-weight:500;font-size:12px">View Wishlist</a><button onclick="document.getElementById(\'wlToast\').style.transform=\'translateY(-100%)\'" style="background:none;border:none;color:#fff;font-size:18px;cursor:pointer;padding:0 0 0 10px;opacity:0.6">&#215;</button>';
  document.body.appendChild(d);

  // Update header heart
  function updateH(){
    var c=document.querySelector(".js-wishlist-count");
    var h=document.querySelector(".site-header__wishlist");
    if(c&&h){
      var n=parseInt(c.textContent.replace(/[^0-9]/g,""))||0;
      if(n>0){h.classList.add("has-items");}
      else{h.classList.remove("has-items");}
    }
  }

  // Show toast
  function showT(m,l){
    var t=document.getElementById("wlToast");
    if(!t)return;
    document.getElementById("wlToastText").textContent=m;
    document.getElementById("wlToastLink").style.display=l?"inline":"none";
    t.style.transform="translateY(0)";
    t.style.pointerEvents="auto";
    clearTimeout(window._wt);
    window._wt=setTimeout(function(){
      t.style.transform="translateY(-100%)";
      t.style.pointerEvents="none";
    },4000);
  }

  // Watch wishlist count changes
  var c=document.querySelector(".js-wishlist-count");
  if(c){
    new MutationObserver(function(){updateH();}).observe(c,{childList:true,characterData:true,subtree:true});
  }
  updateH();

  // Listen for wishlist button clicks
  document.addEventListener("click",function(e){
    var b=e.target.closest(".js-btn-wishlist");
    if(b){
      setTimeout(function(){
        updateH();
        var t=b.getAttribute("title")||b.getAttribute("data-original-title")||"";
        if(t==="Go to wishlist"){
          showT("Removed from wishlist",false);
        }else{
          showT("Added to wishlist",true);
        }
      },500);
    }
  });
});